import { CarouselApi } from "@/components/ui/carousel";

const NumberNavigation = ({
  currentIndex,
  carouselApi,
}: {
  currentIndex: number;
  carouselApi: CarouselApi;
  index: number;
}) => {
  const totalSlides = carouselApi?.slideNodes().length ?? 0;
  return (
    <div className="flex gap-2 text-sm text-white">
      {currentIndex + 1} / {totalSlides}
    </div>
  );
};

export default NumberNavigation;
